import { createSelector } from "@reduxjs/toolkit";

export const permissionsSelector = createSelector(
  (state) =>state.permissions.permissions,
  (a) => a
);
